export function getFileName(fileUrl: string): string {
    return fileUrl.split('/').pop()!;
  }


